// i18nSurveyCustomer
export default {
    Title: {
        MainTitle: "Trên thang điểm 10, Bạn vui lòng đánh giá mức độ hài lòng với MISA TaskGo",
        NoteTitle: "Xin hãy cho biết lý do bạn chưa hài lòng với sản phẩm?",
        DesTitle1: "Chúng tôi cần làm gì để mang lại trải nghiệm tốt hơn cho bạn? Lý do khác:",
        DesTitle2: "Chúng tôi cần làm gì để mang lại thêm nhiều lợi ích hơn nữa cho bạn?",
        DesTitle3: "Thật tuyệt! Có điều gì chúng tôi cần làm tốt hơn nữa không?",
        DesInput: "Nhập góp ý",
    },
    SurveyState: {
        NotGood: "Chưa hài lòng",
        Good: "Hài lòng",
        VeryGood: "Tuyệt vời",
    },

    ReasonType: {
        ReasonOther: "Lý do khác",
        ProductNotGood: "Sản phẩm không đáp ứng nhu cầu",
        ProductError: "Sản phẩm hay bị lỗi",
        SupportServiceNotGood: "Dịch vụ tư vấn hỗ trợ KH kém",
        HighPrice: "Giá thành cao",
        UseConvenient: "Thao tác sử dụng không thuận tiện",
        SlowProcessingSpeed: "Tốc độ xử lí chậm",
        SecurityNotGood: "Bảo mật phần mềm kém",
        TransferNotGood: "Công tác tập huấn triển khai chưa tốt"
    },

    LogFireBase: {
        GroupType: "Bắt đầu sử dụng",
        BusinessType: "Khảo sát",
    }
}